<template>
  <div class="main-container translations-configuration">
    <div v-if="canShowExportLoader || exportLoading" class="translations-loader d-flex justify-content-center mb-3 height-100vh ">
      <b-spinner label="Loading..." class="margin-auto"></b-spinner>
    </div>
    <h1>{{ $t("translations.title") }}</h1>
    <b-card class="default">
      <b-row>
        <b-col md="4">
          <b-form-group
            :key="$i18n.locale"
            id="type-group"
            :label="$t('translations.selectElementType')"
            label-for="selectElementType-select"
          >
            <b-form-select
              id="selectElementType-select"
              v-model="selectedElementType"
              :options="elementTypes"
              @change="handleChange()"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="4" v-if="selectedElementType == 'bordereaux'">
          <b-form-group
            :key="$i18n.locale"
            id="bop-group"
            :label="$t('translations.selectBordereauxType')"
            label-for="selectBordereauxType-select"
          >
            <b-form-select
              id="selectBordereauxType-select"
              v-model="selectedBopModel"
              :options="bopModels"
              value-field="bopModel.key"
              text-field="translation.name"
              @change="handleChange()"
            ></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="4" v-if="selectedBopModel != null">
          <b-form-group
            :key="$i18n.locale"
            id="bop-group"
            :label="$t('translations.selectReference')"
            label-for="selectReference-select"
          >
            <b-form-select
              id="selectReference-select"
              v-model="selectedReference"
              :options="references"
              value-field="value"
              text-field="text"
              @change="handleChange()"
            ></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <div class="group-button-table d-flex flex-wrap align-items-center coefficient-toolbar mt-3 justify-content-between">
      <div class="d-flex flex-wrap">
        <button
          v-if="selectedElementType !== 'bordereaux'"
          type="button"
          class="btn btn-secondary mr-2 mb-1 d-flex align-items-center"
          @click="handleImport"
        >
          {{ $t('translations.import') }}
        </button>
        <button
          v-if="selectedElementType !== 'bordereaux'"
          type="button"
          class="btn btn-secondary mr-2 mb-1 d-flex align-items-center"
          @click="exportFile"
        >
          {{ $t('translations.export') }}
        </button>
                <button
          type="button"
          class="btn btn-primary mr-2 mb-1 d-flex align-items-center"
          :disabled="!hasModifications"
          @click="save"
        >
          {{ $t('translations.saveOperation') }}
        </button>
      </div>
      <div class="d-flex"></div>
    </div>
    <DataTable
      ref="table"
      :columns="dtColumns"
      :url="url"
      :timeout="30000"
      trackBy="id"
      :searchable="true"
      :searchLabel="$t('translations.search').toString()"
      :parseResponse="parseResponse"
    >
      <template v-for="col in editableColumnSlots" v-slot:[col.slot]="{ row }">
        <input
          v-if="col.editable"
          class="form-control form-control-sm"
          :placeholder="col.label"
          :value="getValue(row, col.key)"
          @input="onFieldInput(row, col.key, $event.target.value)"
        />
        <span v-else>{{ getValue(row, col.key) }}</span>
      </template>
    </DataTable>
    <div class="group-button-table d-flex flex-wrap align-items-center coefficient-toolbar mt-3 justify-content-between">
      <div class="d-flex flex-wrap">       
        <button
          v-if="selectedElementType !== 'bordereaux'"
          type="button"
          class="btn btn-secondary mr-2 mb-1 d-flex align-items-center"
          @click="handleImport"
        >
          {{ $t('translations.import') }}
        </button>
        <button
          v-if="selectedElementType !== 'bordereaux'"
          type="button"
          class="btn btn-secondary mr-2 mb-1 d-flex align-items-center"
          @click="exportFile"
        >
          {{ $t('translations.export') }}
        </button>
         <button
          type="button"
          class="btn btn-primary mr-2 mb-1 d-flex align-items-center"
          :disabled="!hasModifications"
          @click="save"
        >
          {{ $t('translations.saveOperation') }}
        </button>
      </div>
      <div class="d-flex"></div>
    </div>

    <ImportLoadingModal ref="importModal" @handleImportSuccess="handleImportSuccess"/>
  </div>
</template>

<script lang="ts">
import DataTable from '@/components/Shared/Table/DataTable.vue';
import ImportLoadingModal from "@/components/Translations/ImportLoadingModal.vue";
import { apiClient } from '@/http/apiClient';
import { loadLanguageAsync } from "@/i18n";
import BopModelService from "@/services/BopModelService";
import ExportService,{ ExportDto } from "@/services/ExportService";
import InterfaceElementService from "@/services/InterfaceElementService";
import LanguageService from "@/services/LanguageService";
import SitesServices from "@/services/SitesServices";
import TranslationService from "@/services/TranslationService";
import Constants from "@/utils/Constants";
import { RubriqueEnum } from "@/utils/Enums";
import ExportBopModelHelper from "@/utils/ExportHelper";
import { Component,Vue,Watch } from "vue-property-decorator";



type Data = {
  columns: Array<Object>;
};
enum ElementTypes {
  bordereaux = "bordereaux",
  interface = "interface",
  sites = "sites",
}
@Component({
  components: {
    DataTable,
    ImportLoadingModal: ImportLoadingModal
  },
})
export default class Translations extends Vue {
  showModal: boolean = false;
  modifiedTranslations: Array<Object> = [];

  elementTypes: Array<any> = [
    {
      text: this.$t("translations.bordereaux").toString(),
      value: ElementTypes.bordereaux,
    },
    {
      text: this.$t("translations.interface").toString(),
      value: ElementTypes.interface,
    },
    {
      text: this.$t("translations.sites").toString(),
      value: ElementTypes.sites,
    },
  ];
  selectedElementType: any = ElementTypes.interface;
  bopModels: Array<Object> = [];
  selectedBopModel: any = null;
  references: Array<Object> = [];
  selectedReference: any = null;
  url: string = InterfaceElementService.getTranslationsUrl();
  exportUrl: string = ExportService.getUrl();
  // Local export loader flag (store may also drive global one)
  public exportLoading: boolean = false;

  // Dynamic language-driven column definitions
  baseColumns: Array<{ key: string; label: string; editable: boolean }> = [];

  public data: Data = {
    columns: [],
  };
  get canShowExportLoader():boolean{
    return this.$store.state.showExportLoader;
  }
  async exportFile() {
    try {
      this.exportLoading = true;
      const response = await apiClient.get(this.exportUrl);
      const blob = response.data as  ExportDto;
      // Attempt to read filename from Content-Disposition header
      ExportBopModelHelper.exportData(blob);

    } catch (e) {
      this.$notify({
        group: 'globalError',
        type: 'error',
        title: this.$t('translations.exportErrorTitle').toString() || 'Export Error',
        text: this.$t('translations.exportErrorText').toString() || 'Unable to download export file.',
        duration: 8000
      });
    } finally {
      this.exportLoading = false;
    }
  }
    handleImport() {
    (<ImportLoadingModal>this.$refs.importModal).openImportModal();
  }
    public handleImportSuccess() {
    this.handleChange();
    this.refresh();
  }
  public handleChange(): void {
    this.modifiedTranslations = [];
    (<any>this.$refs.table).hasBeenModified = false;
    switch (this.selectedElementType) {
      case ElementTypes.bordereaux:
        let queryParams = { bopModelKey: "", referenceKey: "" };
        // if(this.selectedBopModel == null || this.selectedReference == null){
        //   return;
        // }
        if (this.selectedBopModel != null)
         queryParams.bopModelKey = this.selectedBopModel;
        if (this.selectedReference != null) queryParams.referenceKey = this.selectedReference;
        this.url = TranslationService.getTranslationsUrl(queryParams);
        break;
      case ElementTypes.interface:
        this.url = InterfaceElementService.getTranslationsUrl();
        break;
      case ElementTypes.sites:
        this.url = SitesServices.getTranslationsUrl();
        break;
    }
    this.$nextTick(() => {
      const table: any = this.$refs.table;
      if (table && table.api && this.url) table.api.load(this.url);
    });
  }

  public refresh(): void {
    this.modifiedTranslations = [];
    const table: any = this.$refs.table; if (table && table.api && this.url) table.api.load(this.url);
  }

  public async save() {
    for (let i = 0; i < this.modifiedTranslations.length; i++) {
      const modifiedTranslation = this.modifiedTranslations[i];
      try {
        switch (this.selectedElementType) {
          case ElementTypes.bordereaux:
            await TranslationService.save(modifiedTranslation);
            break;
          case ElementTypes.interface:
            await InterfaceElementService.addTranslations(modifiedTranslation);
            break;
          case ElementTypes.sites:
            await SitesServices.saveTranslations(modifiedTranslation);
            break;
        }
        this.$notify({
          group: "global",
          type: "success",
          title: this.$t("translations.saveSuccess.title").toString(),
          text: this.$t("translations.saveSuccess.text").toString(),
        });
      } catch (err: any) {
        this.$notify({
          group: "globalError",
          type: "error",
          title: this.$t("translations.saveError.title").toString(),
          text: this.$t("translations.saveError.text").toString(),
          duration: Constants.DEFAULT_WAIT_ERROR_NOTIFICATIONS,
        });
      }
    }
    await loadLanguageAsync(this.$i18n.locale, true);
    this.handleChange();
    this.refresh();
  }
  private async loadElements() {
    this.baseColumns = [];
    LanguageService.getLanguages().then((res) => {
      this.baseColumns.push({ key: 'name', label: this.$t('translations.name').toString(), editable: false });
      res.data.forEach((element: any) => {
        this.baseColumns.push({ key: 'translations.' + element.code, label: element.code, editable: true });
      });
    });

    let responseBopModel = await BopModelService.getBopModels(
      this.$i18n.locale
    );
    this.bopModels.push({
      translation: { name: this.$t("bopModelSetup.allBops") },
      bopModel: { key: null },
    });
    if (responseBopModel.status === 200) {
      this.bopModels = responseBopModel.data;
    }

    this.references.push(
      ...[
        {
          text: this.$t("bopModelSetup.allReferences"),
          value: null,
        },
        {
          text: this.$t("bopModelSetup.OperationPrincipale"),
          value: RubriqueEnum.OperationPrincipal,
        },
        {
          text: this.$t("bopModelSetup.OperationDiverse"),
          value: RubriqueEnum.OperationDiverse,
        },
        {
          text: this.$t("bopModelSetup.CoefficientDimensions"),
          value: RubriqueEnum.CoefficientDimensions,
        },
      ]
    );
  }
  public mounted() {
    this.loadElements();
  }
  @Watch("$i18n.locale")
  private onLocaleChange() {
    this.loadElements();
  }

  // DataTable column mapping
  get dtColumns(): Array<{ key: string; label: string; sortField?: string; slot: string }> {
    return this.baseColumns.map(c => ({ key: c.key, label: c.label, sortField: c.key, slot: 'col_' + c.key.replace(/\./g,'_') }));
  }
  get editableColumnSlots() {
    return this.dtColumns.map(dc => {
      const base = this.baseColumns.find(b => b.key === dc.key);
      return { ...dc, editable: !!base?.editable };
    });
  }

  // Response parsing for DataTable
  parseResponse(resp: any) {
    const data = resp?.data || [];
    return { rows: Array.isArray(data) ? data : (Array.isArray(data?.data) ? data.data : []), pagination: resp?.pagination };
  }

  // Modification tracking
  private markModified(row: any) {
    if (!this.modifiedTranslations.includes(row)) this.modifiedTranslations.push(row);
  }
  get hasModifications(): boolean { return this.modifiedTranslations.length > 0; }

  // Generic path helpers for dotted keys
  getValue(row: any, path: string) {
    return path.split('.').reduce((acc: any, part: string) => acc ? acc[part] : undefined, row);
  }
  private setValue(row: any, path: string, value: any) {
    const parts = path.split('.');
    const last = parts.pop() as string;
    const target = parts.reduce((acc: any, part: string) => {
      if (!acc[part]) acc[part] = {};
      return acc[part];
    }, row);
    target[last] = value;
  }
  onFieldInput(row: any, key: string, value: any) {
    this.setValue(row, key, value);
    this.markModified(row);
  }


}
</script>
<style lang="scss"  scoped>
.translations-loader{
  position: absolute;
  width: 100%;
  background-color: #ffffffc9;
  z-index: 9999;
}
</style>
